import { useTranslation } from "react-i18next";
import { Button } from "@tellescope/ui";
import type { EligibilityAnswerValue } from "./useEligibilityField";

export interface EligibilityStaffPanelProps {
  serviceCode?: string;
  npi?: string;
  payerId?: string;
  memberId?: string;
  isChecking: boolean;
  errorMessage?: string;
  responseErrors?: unknown[];
  value: EligibilityAnswerValue;
  onCheck: () => void;
}

export const EligibilityStaffPanel = ({
  serviceCode,
  npi,
  payerId,
  memberId,
  isChecking,
  errorMessage,
  responseErrors,
  value,
  onCheck,
}: EligibilityStaffPanelProps) => {
  const { t } = useTranslation("forms");
  const notConfigured = t("Not configured");

  return (
    <div className="border rounded-md p-4 flex flex-col gap-3">
      <div className="flex flex-col gap-1 text-xs text-muted-foreground">
        <p>{t("Service Code: {{serviceCode}}", { serviceCode: serviceCode || notConfigured })}</p>
        <p>{t("Provider NPI: {{npi}}", { npi: npi || notConfigured })}</p>
        {!!payerId && <p>{t("Payer ID: {{payerId}}", { payerId })}</p>}
        {!!memberId && <p>{t("Member ID: {{memberId}}", { memberId })}</p>}
      </div>

      <div>
        <Button variant="outline" size="sm" disabled={isChecking} onClick={onCheck}>
          {t("Check Eligibility")}
        </Button>
      </div>

      {!!errorMessage && <p className="text-sm text-destructive">{errorMessage}</p>}

      {!!responseErrors?.length && (
        <pre className="text-xs bg-muted rounded p-2 overflow-x-auto">{JSON.stringify(responseErrors, null, 2)}</pre>
      )}

      {!!value && <pre className="text-xs bg-muted rounded p-2 overflow-x-auto">{JSON.stringify(value, null, 2)}</pre>}
    </div>
  );
};
